import axios from "axios";



axios.interceptors.response.use(
    (resp) => {
        if (process.env.NODE_ENV === "production") {
            let v = process.env.VERSION
            if (v !== localStorage.getItem('Version') && resp.config.method == 'get') {
                localStorage.setItem('Version', v)
                window.location.reload() // For new version, simply reload on any get
            }
        }
        return Promise.resolve(resp)
    })